<template>
  <div>
    <div class="box" style="margin: 20px auto;">
     <!-- 卡片类型切换 -->
     <div class="card-switch">
       <span :class="['switch-item', cardType === 'gift' ? 'active' : '']" @click="switchCard('gift')">
         Gift Card
       </span>
       <span class="divider">|</span>
       <span :class="['switch-item', cardType === 'gold' ? 'active' : '']" @click="switchCard('gold')">
         Gold Card
       </span>
     </div>
     <!-- 无限加载滚动列表 -->
     <div v-infinite-scroll="getMore"
        infinite-scroll-disabled="loading" infinite-scroll-distance="10">
        <div class="box_list" v-for="(item,index) in myCardList" :key="index">	  
          <img class="box_list_lfimg" :src="item.image" :class="item.status==1 ? 'filter' : ''"/>
          <div class="box_list_rt">
            <div class="list_rt_tit">
              {{item.name}}
              <div class="recycle" v-if="item.status!=1" @click="goRecycle(item)">{{ $t("Recycle") }} >></div>
            </div> 
            <div class="list_rt_txt">{{item.create_time}}</div>
            <div class="list_rt_foot">{{item.number}}</div>
            <div class="list_rt_foot">{{item.code}}</div>
          </div>
      </div>
      </div>
	  </div>
    <empty-record v-if='myCardList.length <= 0 && !isMore'></empty-record>
  </div>

</template>

<script>
import { Toast,Indicator,MessageBox } from 'mint-ui'
import HomeCommonSearch from '../common/HomeCommonSearch'
import EmptyRecord from '../../EmptyRecord'
import { getMyCardList, getMyGoldCardList } from '../../../api/giftcard'
export default {
  name: 'MyCardList',
  components: {
    HomeCommonSearch,
    EmptyRecord
  },
  data() {
    return {
      loading: false, // 是否加载更多
      isMore: true,// 是否有更多
      params:{page: 0,},
      myCardList: [], // 商品列表
      cardType: 'gift' // 卡片类型
    }
  },
  created() {

  },
  mounted() {
    const type = this.$route.query.type == 2 ? 'gold' : 'gift'
    this.switchCard(type)
  },
  methods:{
    switchCard(type) {
      if (this.cardType === type) return
      this.cardType = type
      // 重置分页状态
      this.params.page = 0
      this.isMore = false
      this.loading = true
      this.myCardList = []
      this.getMyCardList()
    },
    goRecycle(item){
      const msg = this.cardType == 'gold' ? "Gold Card Recycling?" : "Gift Card Recycling?";
      MessageBox({
        title: this.$t("MessageBox.Tips"),
        message: msg,
        confirmButtonText: this.$t("MessageBox.Confirm"),
        cancelButtonText: this.$t("MessageBox.Cancel"),
        showCancelButton: true,
      }).then((action) => {
        if (action == "confirm") {
          this.$router.push({ name: "GiftSave", query: { number: item.number, code: item.code, type: this.cardType === 'gold' ? 2 : 1 }});
        }
      })
    },
    copySuccess(sn) {
      this.$copyText(sn).then(
        (e) => {
          Toast(this.$t('succ'))
          console.log(e);
        }, (e) => {
          Toast(this.$t('err'))
          console.log(e);
        }
      );
    },
    /*
    * getMore: 无限滚动加载
    */
    getMore() {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getMyCardList(true)
      }
    },
    getMyCardList(ispush) {
      const api = this.cardType === 'gold' ? getMyGoldCardList : getMyCardList
      api(
        this.params
      ).then(res => {
        this.buildData(ispush, res)
      })
    },
    buildData(ispush, res) {
      if (res) {
        if (ispush) {
          this.myCardList = this.myCardList.concat(res.result.data)
        } else {
          this.myCardList = res.result.data
        }
        if (res.result.data.length < 10) {
          this.isMore = false
        } else {
          this.isMore = true
        }
      }
    },
  }
}
</script>

<style scoped lang="scss">
.recycle{
  cursor: pointer;
  background: linear-gradient(90deg, #E8090C 0%, #F3611E 100%);
  padding: 5px 10px;
  border-radius: 5px;
  color: #ffffff;
  float: right;
}
.filter{
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
.cursor:hover{
			cursor: pointer;
		}
.card-switch {
  position: relative;
  top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0 25px;
  font-size: 14px;
  color: #999;

  .switch-item {
    cursor: pointer;
    padding: 0 8px;
    transition: all 0.3s;
  }

  .active {
    color: #EF4618;
    font-weight: bold;
    text-decoration: underline;
  }

  .divider {
    margin: 0 5px;
  }
}
		.box{
			width: 1200px;
			margin: 20px auto;
			background: #fff;
			border-radius: 4px;
			.box_list{
				border-bottom: 1px solid #F1F1F1;
				display: flex;
				padding: 50px 60px;
				.box_list_lfimg{
					width: 254px;
					height: 160px;
					object-fit: contain;
				}
				.box_list_rt{
					width: 800px;
					margin-left: 30px;
					.list_rt_tit{
						font-size: 18px;
						color: #000000;
						line-height: 25px;
					}
					.list_rt_txt{
						font-size: 18px;
						color: #000000;
						line-height: 60px;
					}
					.list_rt_foot{
						text-align: right;
						font-size: 16px;
						color: #000000;
						line-height: 40px;
						img{
							width: 20px;
							height: 20px;
							margin-left: 18px;
							// position: relative;
							// top: 2px;
						}
					}
				}
			}
		}
</style>
